import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PrimaryNavigation from '../../components/ui/PrimaryNavigation';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import Seo from '../../components/Seo';
import { supabase } from '../../lib/supabaseClient';
import { NoticeEditorModal } from '../admin-dashboard/components/NoticeManagementPanel';

const AdminNoticeEditor = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const noticeId = searchParams?.get('id') || '';

  const [initial, setInitial] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!noticeId) {
        setInitial(null);
        return;
      }

      setIsLoading(true);
      try {
        const baseQuery = supabase.from('ch_notices');
        let data;
        let err;

        ({ data, error: err } = await baseQuery
          .select('id, title, author_name, is_published, youtube_url, content_html, files:ch_notice_files(file_path, original_name, content_type, size_bytes)')
          .eq('id', noticeId)
          .maybeSingle());

        const errMsg = String(err?.message || '');
        const isYoutubeColumnMissing =
          errMsg.includes("Could not find the 'youtube_url'") ||
          errMsg.includes('column') && errMsg.includes('youtube_url') && errMsg.includes('does not exist');

        if (err && isYoutubeColumnMissing) {
          ({ data, error: err } = await baseQuery
            .select('id, title, author_name, is_published, content_html, files:ch_notice_files(file_path, original_name, content_type, size_bytes)')
            .eq('id', noticeId)
            .maybeSingle());
        }

        setInitial(data || null);
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, [noticeId]);

  return (
    <div className="min-h-screen bg-background">
      <Seo title={noticeId ? '공지 수정' : '공지 등록'} canonicalPath="/admin-notice-editor" />
      <PrimaryNavigation />
      <BreadcrumbNavigation />

      <main className="pt-28 lg:pt-28 pb-20 md:pb-24 lg:pb-16 px-4 sm:px-5 md:px-6 lg:px-8">
        <div className="max-w-screen-2xl mx-auto">
          {isLoading ? (
            <div className="bg-card rounded-lg shadow-gaming-md p-6 border border-border">
              <p className="text-sm text-muted-foreground caption">로딩 중...</p>
            </div>
          ) : null}

          <NoticeEditorModal
            isOpen
            initial={initial}
            onClose={() => navigate('/admin-dashboard')}
            onSaved={() => navigate('/admin-dashboard')}
          />
        </div>
      </main>
    </div>
  );
};

export default AdminNoticeEditor;
